import { ENV_COUNTRY } from 'settings/env';

export function isFr(): boolean {
  return ENV_COUNTRY === 'fr';
}

export function isUk(): boolean {
  return ENV_COUNTRY === 'uk';
}
